"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletProvider = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _remeda = require("remeda");
class WalletProvider {
  constructor(window) {
    (0, _defineProperty2.default)(this, "wallets", {});
    this.window = window;
  }
  async get(type, parameters) {
    let factory = this.wallets[type];
    if (!factory) {
      throw new Error(`Factory for wallet type '${type}' not found.`);
    }
    return await factory.createWallet(parameters, this.window);
  }
  addType(wallet) {
    this.wallets[wallet.type] = wallet;
    return this;
  }
  allowedTypes(dumbapp, overrideStrategy) {
    const types = Object.values(this.wallets).map(it => it.type);
    let strategy = (dumbapp === null || dumbapp === void 0 ? void 0 : dumbapp.walletStrategy) || {
      type: "auto"
    };
    if (overrideStrategy) {
      strategy = {
        type: overrideStrategy
      };
    }
    switch (strategy.type) {
      case "required":
        return (0, _remeda.intersection)(strategy.wallets, types);
      case "priority":
        let list = strategy.wallets;
        let others = (0, _remeda.difference)(types, list);
        return list.concat(others);
      default:
        return types;
    }
  }
}
exports.WalletProvider = WalletProvider;
//# sourceMappingURL=WalletProvider.js.map